import './sentry';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
const quote = document.getElementById('cordero-quote');
// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, quote);
